// src/layout/AdminLayout.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SidebarNav from '../shared/SidebarNav';

const styles = {
  layout: { display: 'grid', gridTemplateColumns: '260px 1fr', minHeight: '100vh', background: '#faf8f5' },
  sidebar: { borderRight: '1px solid #e7e0d6', background: '#fff', overflowY: 'auto' },
  main: { display: 'flex', flexDirection: 'column' },
  topbar: {
    height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 16px', background: '#fff', borderBottom: '1px solid #e7e0d6', position: 'sticky', top: 0, zIndex: 3
  },
  brand: { display: 'flex', alignItems: 'center', gap: 10 },
  logo: { height: 36 },
  title: { fontSize: 18, margin: 0, color: '#5c4a3b', letterSpacing: 1 },
  crumbs: { fontSize: 13, color: '#7a6d60' },
  content: { padding: 20 },
  footer: { borderTop: '1px solid #e7e0d6', textAlign: 'center', color: '#777', padding: 10, marginTop: 'auto' },
  search: {
    width: 320, maxWidth: '50vw', border: '1px solid #e1d9cd', borderRadius: 8, padding: '8px 10px',
    fontSize: 14, background: '#fdfbf7'
  }
};

function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return <span>Dashboard</span>;
  const map = (p) => p.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  return (
    <span>
      {parts.map((p, i) => {
        const label = map(p);
        const to = '/' + parts.slice(0, i + 1).join('/');
        const last = i === parts.length - 1;
        return (
          <span key={to}>
            {!last ? <Link to={to} style={{ color: '#7a6d60', textDecoration: 'none' }}>{label}</Link> : <strong>{label}</strong>}
            {!last && ' / '}
          </span>
        );
      })}
    </span>
  );
}

export default function AdminLayout({ children }) {
  return (
    <div style={styles.layout}>
      <aside style={styles.sidebar}>
        <SidebarNav />
      </aside>

      <section style={styles.main}>
        <header style={styles.topbar}>
          <div style={styles.brand}>
            <img src="/oppies-logo.png" alt="OPPIES" style={styles.logo} />
            <h1 style={styles.title}>OPPIES Admin</h1>
          </div>
          {/* simple placeholder search (wire up later) */}
          <input placeholder="Search (email, name, ID)�" style={styles.search} />
        </header>

        <div style={{ padding: '10px 20px 0' }}>
          <div style={styles.crumbs}><Breadcrumbs /></div>
        </div>

        <main style={styles.content}>{children}</main>

        <footer style={styles.footer}>
          powered by ECLIPTEK
        </footer>
      </section>
    </div>
  );
}
